import styled from 'styled-components';

export const SubscriptionCardWrapper = styled.div`
  padding: 20px;
  border-radius: 30px;
  border: 1px solid rgba(33, 33, 33, 0.1);

  & .specialist-profile {
    padding: 0px 0px 24px 0px;
    border-bottom: 1px solid rgba(33, 33, 33, 0.1);
  }

  & .subscription-title {
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-weight: 600;
    font-size: 18px;
    line-height: 20px;
    color: #1d201f;
    margin-bottom: 8px;
    margin-top: 24px;

    & ion-icon {
      font-size: 24px;
    }

    &.active {
      & ion-icon {
        color: #26b183;
      }
    }

    &.pause {
      & ion-icon {
        color: #f9de33;
      }
    }

    &.cancel {
      & ion-icon {
        color: #f24e1e;
      }
    }

    &.expiring-soon {
      & ion-icon {
        color: #ff9900;
      }
    }
  }

  & .subscription-date-wrapper {
    margin-bottom: 12px;

    & .subscription-date-progress {
      --background: #e5e5e5;
      --progress-background: #26b183;
      height: 7px;
      border-radius: 9px;

      &::part(progress) {
        border-radius: 9px;
      }

      &.pause {
        --progress-background: #f9de33;
      }

      &.cancel,
      &.expiring-soon {
        --progress-background: #f24e1e;
      }
    }
  }

  & .subscription-date {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 5px;

    b {
      font-weight: 600;
    }
  }

  & .subscription-balance-wrapper {
    margin-bottom: 32px;
  }

  & .subscription-balance {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 5px;

    b {
      font-weight: 600;
    }
  }

  & .balance-list {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    column-gap: 8px;

    & .balance-item {
      flex: 1;
      width: 100%;
      height: 7px;
      background: #e5e5e5;
      border-radius: 10px;

      &.filled {
        background: #26b183;
      }
    }
  }

  & .subscription-info {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
    margin-bottom: 24px;
  }

  & .subscription-date-price-info {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    color: rgba(33, 33, 33, 0.5);

    b {
      color: #212121;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  }

  & .subscription-cancel-desc {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: rgba(33, 33, 33, 0.5);
  }
`;
